import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";
import { toPrecision, assignRecursive } from "../../utils";
import { Autoplay } from "../../commander/Types";

const details = createSlice({
  name: "autoplay",
  initialState: initialState.autoplay,
  reducers: {
    setAutoplay(state, action: PayloadAction<Autoplay>) {
      const { value, active: activeVal } = action.payload;
      const active = typeof activeVal === "boolean" ? activeVal : value !== 0;
      let limit;

      if (action.payload.limit) {
        limit = assignRecursive(state.limit, action.payload.limit)
      } else {
        limit = state.limit;
      }

      return { ...state, value, active, limit };
    },
    updateAutoplay(
      state,
      action?: PayloadAction<{ balanceUpdate: number }> | null
    ) {
      const value = Math.max(state.value - 1, 0);
      if (action?.payload?.balanceUpdate && state.limit.loss.active) {
        const current = toPrecision(
          state.limit.loss.current - action.payload.balanceUpdate,
          4
        );
        const active = value !== 0 && current < state.limit.loss.value;

        return {
          ...state,
          active,
          value: active ? value : 0,
          limit: {
            ...state.limit,
            loss: {
              ...state.limit.loss,
              current: active ? current : 0,
              active: active && state.limit.loss.active,
            },
          },
        };
      }

      // return state;
      return { ...state, value, active: value !== 0 };
    },
  },
});

export const { setAutoplay, updateAutoplay } = details.actions;

export default details;
